import Error from '../model/Error';
import PhysicalAccessMediumIdentification from '../dto/PhysicalAccessMediumIdentification';
import axios from 'axios';

export default class PhysicalAccessLogRepository {
    static findByClub(clubId, filters) {
        return new Promise((resolve, reject) => {
            const params = {
                filters,
            };
            axios
                .get(`/club/clubs/${clubId}/physical-access/log`, { params })
                .then((response) => resolve(response.data.data.map((data) => PhysicalAccessMediumIdentification.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findByClubForStats(clubId, filters) {
        return new Promise((resolve, reject) => {
            const params = {
                filters,
            };
            axios
                .get(`/club/clubs/${clubId}/physical-access/statistics`, { params })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
